import React /* , { useEffect } */ from "react";
//import AOS from "aos";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { StickyBtns } from "../index";

export const Layout = ({ children, footerProps }) => {
  return (
    <div className="font-futuraLt">
      <Header />
      <StickyBtns />
      {children}
      <Footer {...footerProps} />
    </div>
  );
};
